module.exports = __webpack_public_path__ + "assets/359180ef7c5316ff869454c7fd2a3bd1.mp3";